import { createSlice } from '@reduxjs/toolkit'
import { CryptoUtils } from 'src/utils/Crypto.utils'

export enum SNSLoginType {
  GOOGLE = 0,
  FACEBOOK = 1,
}

export type LoginPageStateType = {
  // null 기본 가입창
  Status: 'default' | 'isMemberConfirm' | 'pinMoreThanFiveTimes' | 'isNotApp'
  pinValue: string
  pinHidden: boolean
  SNSType: SNSLoginType
  Email: string
  VerifyPin: string
  pinHash: string
  Token: string
}
const initialState: LoginPageStateType = {
  Status: 'default',
  pinValue: '',
  pinHidden: true,
  SNSType: 0,
  Email: '',
  VerifyPin: '',
  pinHash: '',
  Token: '',
}

const LoginPageSlice = createSlice({
  name: 'LoginPage',
  initialState,
  reducers: {
    setStatus(state, action) {
      state.Status = action.payload
    },
    setPinValue(state, action) {
      state.pinValue = action.payload
      state.VerifyPin = CryptoUtils.CreateVerifyPin(state.pinValue, state.Email).cipher
      state.pinHash = CryptoUtils.CreateVerifyPin(state.pinValue, '').hash
    },
    setPinHidden(state, action) {
      state.pinHidden = action.payload
    },
    setSNSType(state, action) {
      state.SNSType = action.payload
    },
    setEmail(state, action) {
      state.Email = action.payload
    },
    ResetEmail(state) {
      state.Email = ''
    },
    ResetPinValue(state) {
      state.pinValue = ''
    },
  },
})

export const {
  ResetEmail,
  ResetPinValue,
  setStatus,
  setPinValue,
  setPinHidden,
  setSNSType,
  setEmail,
} = LoginPageSlice.actions

export default LoginPageSlice.reducer
